import {
  LOGIN,
  REGISTER,
  ERRORS,
  LOGIN_ERRORS,
  USER,
  CLEAR_USER,
  UPDATE_USER,
} from "./userTypes";

const initialState = {
  login: null,
  register: null,
  errors: null,
  login_errors: null,
  user: "",
  update_user: null,
  auth: null,
};

export const useReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER:
      return {
        ...state,
        register: action.payload,
      };
    case LOGIN:
      sessionStorage.setItem(
        "auth_session",
        JSON.stringify(action.payload.data.token)
      );
      sessionStorage.setItem("auth_user", JSON.stringify(action.payload.data));
      return {
        ...state,
        login: action.payload,
      };
    case USER:
      return {
        ...state,
        user: JSON.parse(sessionStorage.getItem("auth_user"))
          ? action.payload
          : null,
      };
    case UPDATE_USER:
      return {
        ...state,
        update_user: action.payload,
      };
    case CLEAR_USER:
      return {
        ...state,
        user: "",
      };
    case ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case LOGIN_ERRORS:
      return {
        ...state,
        login_errors: action.payload,
      };

    default:
      return state;
  }
};
